var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mastercard_vector",
    "data-name": "mastercard vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.731,
    height: 27.653,
    viewBox: "0 0 44.731 27.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6012",
    "data-name": "Path 6012",
    d: "M20.852,27.907H8.757V6.168h12.1Z",
    transform: "translate(7.561 -3.21)",
    fill: "#ff5f00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6013",
    "data-name": "Path 6013",
    d: "M17.087,18.407a13.8,13.8,0,0,1,5.28-10.872,13.823,13.823,0,1,0,0,21.737A13.8,13.8,0,0,1,17.088,18.4Z",
    transform: "translate(-0.002 -4.578)",
    fill: "#eb001b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6014",
    "data-name": "Path 6014",
    d: "M34.367,18.406A13.823,13.823,0,0,1,12,29.275a13.823,13.823,0,0,0,0-21.74A13.823,13.823,0,0,1,34.367,18.4Z",
    transform: "translate(10.365 -4.578)",
    fill: "#f79e1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardIcon);
export default __webpack_public_path__ + "static/media/master-card-icon.34c09aa9ed69b09d45031fbaa6d06923.svg";
export { ForwardRef as ReactComponent };